import { styled, TextField as TextFieldBase } from '@mui/material';

export const TextField = styled(TextFieldBase)`
  &.MuiTextField-root .MuiInputBase-input {
    padding: 10px 14px;
  }
`;
